module.exports = __webpack_public_path__ + "img/pisa.97e9c5ca.png";